import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import Carousel from "components/carousel/Carousel";
import { newFeaturesCampaigns } from "constants/campaigns";
import {
  ADD_TAG_BASED_ON_TEXT,
  FEEDBACK_REQUEST_RULE,
  FOLLOW_UP_RULE,
  IRuleTemplate,
  LANGUAGE_BASED_ASSIGNMENT,
  NEW_TICKET_CONFIRMATION_RULE,
  PENDING_TO_CLOSED_RULE,
} from "constants/rules/premade-rules";
import { useNewFeatureForAgents } from "hooks/use-new-feature-for-agents";
import { AutomationsRoutes } from "routes/automations/constants";
import { AutomationCarouselCard } from "routes/automations/shared/components/AutomationCarouselCard";
import { selectIsAdmin } from "store/entities/agents";

import { trackWorkflowCreationStarted } from "../utils";

const premadeRules: IRuleTemplate[] = [
  NEW_TICKET_CONFIRMATION_RULE,
  FOLLOW_UP_RULE,
  ADD_TAG_BASED_ON_TEXT,
  FEEDBACK_REQUEST_RULE,
  PENDING_TO_CLOSED_RULE,
  LANGUAGE_BASED_ASSIGNMENT,
];

interface IRuleProps {
  rule: IRuleTemplate;
}

const PremadeRule: FC<IRuleProps> = ({ rule }) => {
  const history = useHistory();
  const isAdmin = useSelector(selectIsAdmin);
  const { isNewForAgent, featureFlagValue, setAgentFlagCallback } = useNewFeatureForAgents(
    newFeaturesCampaigns.hasSeenLanguageCondition.flag,
    newFeaturesCampaigns.hasSeenLanguageCondition.campaignStartDate
  );

  const handleRuleClicked = (): void => {
    history.push(AutomationsRoutes.AddRule, { rule: JSON.stringify(rule) });

    if (rule.premadeType === "LANGUAGE_BASED_ASSIGNMENT" && isNewForAgent && !featureFlagValue) {
      setAgentFlagCallback();
    }

    trackWorkflowCreationStarted("main", rule.premadeType);
  };
  return (
    <AutomationCarouselCard
      onClick={handleRuleClicked}
      disabled={!isAdmin}
      name={rule.name ?? ""}
      icon={rule.icon}
      premadeType={rule.premadeType}
    />
  );
};

export const PremadeRulesCarousel: FC = () => {
  return (
    <Carousel>
      {premadeRules.map(rule => (
        <PremadeRule rule={rule} key={rule.premadeType} />
      ))}
    </Carousel>
  );
};
